import style from "./ExploreBlock.module.scss";

function ExploreIcon() {
	return (
		<svg
			className={style.icon}
			width="619"
			height="591"
			viewBox="0 0 619 591"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink">
			<path
				d="M439.022 88.665L438.05 88.8984L438.05 88.8984L439.022 88.665ZM393.635 149.169L392.992 149.935L393.635 149.169ZM505.21 202.89C505.469 203.377 506.075 203.562 506.563 203.302L514.506 199.072C514.994 198.813 515.179 198.207 514.919 197.72C514.66 197.232 514.054 197.047 513.566 197.307L506.505 201.067L502.745 194.006C502.485 193.518 501.88 193.334 501.392 193.593C500.905 193.853 500.72 194.458 500.98 194.946L505.21 202.89ZM507.049 202.712C507.563 201.026 508.056 199.363 508.528 197.722L506.606 197.169C506.137 198.8 505.647 200.453 505.136 202.128L507.049 202.712ZM511.114 188.135C511.964 184.753 512.718 181.472 513.38 178.29L511.422 177.882C510.766 181.036 510.018 184.291 509.175 187.648L511.114 188.135ZM515.167 168.606C515.72 165.14 516.155 161.804 516.476 158.596L514.486 158.396C514.169 161.564 513.74 164.861 513.192 168.291L515.167 168.606ZM517.131 148.531C517.228 145.014 517.172 141.673 516.972 138.501L514.976 138.626C515.172 141.735 515.227 145.015 515.132 148.476L517.131 148.531ZM515.784 128.523C515.148 125.016 514.305 121.761 513.272 118.747L511.38 119.396C512.378 122.307 513.197 125.464 513.816 128.879L515.784 128.523ZM509.116 109.52C507.354 106.464 505.339 103.755 503.107 101.372L501.647 102.739C503.772 105.008 505.696 107.592 507.384 110.519L509.116 109.52ZM495.289 94.8449C492.434 92.9992 489.38 91.5094 486.177 90.3434L485.493 92.2228C488.565 93.3411 491.483 94.7658 494.204 96.5245L495.289 94.8449ZM476.349 87.8139C473.075 87.2813 469.707 87.0117 466.288 86.9776L466.268 88.9775C469.596 89.0107 472.862 89.273 476.028 89.7879L476.349 87.8139ZM456.21 87.5198C452.9 87.8978 449.575 88.4649 446.27 89.1983L446.703 91.1508C449.944 90.4315 453.2 89.8765 456.437 89.5069L456.21 87.5198ZM436.563 91.8384C433.357 92.8703 430.201 94.0445 427.13 95.3396L427.907 97.1825C430.926 95.9097 434.026 94.7559 437.176 93.7423L436.563 91.8384ZM418.045 99.6475C415.018 101.251 412.119 102.966 409.389 104.768L410.491 106.437C413.165 104.672 416.008 102.99 418.981 101.415L418.045 99.6475ZM401.271 110.801C398.568 113.076 396.144 115.436 394.062 117.843L395.574 119.151C397.578 116.834 399.925 114.548 402.559 112.331L401.271 110.801ZM388.323 126.303C386.685 129.65 385.801 133.035 385.876 136.347L387.876 136.302C387.81 133.379 388.588 130.312 390.119 127.182L388.323 126.303ZM389.367 146.159C390.357 147.474 391.563 148.735 392.992 149.935L394.278 148.403C392.953 147.291 391.855 146.138 390.965 144.956L389.367 146.159ZM392.992 149.935C394.352 151.076 395.696 152.057 397.023 152.886L398.082 151.189C396.842 150.415 395.573 149.49 394.278 148.403L392.992 149.935ZM406.403 156.335C409.923 156.709 413.231 155.999 416.284 154.462L415.385 152.676C412.642 154.057 409.717 154.676 406.614 154.346L406.403 156.335ZM424.092 148.27C426.178 145.952 428.084 143.241 429.804 140.269L428.072 139.268C426.408 142.144 424.58 144.738 422.605 146.932L424.092 148.27ZM434.078 131.477C435.295 128.5 436.361 125.402 437.268 122.267L435.347 121.711C434.458 124.783 433.415 127.814 432.227 130.72L434.078 131.477ZM439.514 112.788C440.129 109.477 440.555 106.219 440.783 103.116L438.788 102.97C438.566 105.994 438.15 109.179 437.548 112.423L439.514 112.788ZM440.771 93.3304C440.611 91.5742 440.354 89.9299 439.994 88.4316L438.05 88.8984C438.383 90.2864 438.626 91.8334 438.779 93.5122L440.771 93.3304ZM439.994 88.4316C439.587 86.7341 439.146 85.067 438.671 83.4303L436.75 83.9867C437.216 85.5934 437.649 87.2307 438.05 88.8984L439.994 88.4316ZM435.322 73.666C434.016 70.3998 432.571 67.2778 430.998 64.3013L429.23 65.2355C430.769 68.1488 432.185 71.2068 433.465 74.4084L435.322 73.666ZM425.676 55.4581C423.695 52.5554 421.582 49.8268 419.353 47.2741L417.846 48.5895C420.023 51.0822 422.088 53.7478 424.023 56.5853L425.676 55.4581ZM412.083 39.9183C409.473 37.5883 406.753 35.4603 403.943 33.5362L402.813 35.1865C405.552 37.0621 408.205 39.1372 410.751 41.4102L412.083 39.9183ZM395.04 28.2641C391.931 26.6908 388.747 25.3431 385.513 24.2235L384.858 26.1134C388.007 27.2035 391.108 28.5159 394.137 30.0487L395.04 28.2641ZM375.518 21.518C372.11 20.8454 368.676 20.4167 365.24 20.2344L365.134 22.2316C368.474 22.4088 371.815 22.8257 375.13 23.4801L375.518 21.518ZM354.882 20.4363C351.441 20.7558 348.026 21.3288 344.664 22.1578L345.143 24.0997C348.407 23.2948 351.724 22.7382 355.067 22.4277L354.882 20.4363ZM334.817 25.394C331.65 26.7094 328.56 28.2733 325.574 30.0882L326.613 31.7973C329.511 30.0357 332.51 28.5177 335.584 27.2411L334.817 25.394ZM317.146 36.124C315.831 37.223 314.546 38.3792 313.292 39.5929L314.684 41.0296C315.902 39.8498 317.151 38.7262 318.428 37.6586L317.146 36.124Z"
				fill="#6371DE"
				fillOpacity="0.5"
			/>
			<g filter="url(#filter0_i_1_21)">
				<rect
					y="93.7378"
					width="270"
					height="270"
					rx="32"
					transform="rotate(-18.9628 0 93.7378)"
					fill="white"
				/>
				<path
					d="M76.818 156.163L65.1251 160.18L66.8347 137.388L74.4983 134.755L76.818 156.163ZM92.7771 150.68L81.0843 154.697L82.7939 131.905L90.4574 129.273L92.7771 150.68Z"
					fill="#6371DE"
					fillOpacity="0.5"
				/>
				<text
					transform="translate(73.8995 185.716) rotate(-18.9628)"
					fill="#6371DE"
					xmlSpace="preserve"
					// style="whiteSpace: pre"
					fontFamily="Poppins"
					fontSize="24"
					fontWeight="600"
					letterSpacing="0em">
					<tspan x="19.9062" y="22.9">
						sky castle in{" "}
					</tspan>
					<tspan x="23.5508" y="51.9">
						anime style
					</tspan>
				</text>
			</g>
			<g filter="url(#filter1_b_1_21)">
				<rect
					x="288.434"
					y="171"
					width="342"
					height="342"
					rx="32"
					transform="rotate(15.1593 288.434 171)"
					fill="url(#paint0_linear_1_21)"
					fillOpacity="0.5"
				/>
				<rect
					x="299.693"
					y="190.627"
					width="310"
					height="310"
					rx="12"
					transform="rotate(15.1593 299.693 190.627)"
					fill="url(#pattern0)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_i_1_21"
					x="0"
					y="1.99998"
					width="346.085"
					height="347.085"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="3" dy="-4" />
					<feGaussianBlur stdDeviation="15" />
					<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.471875 0 0 0 0 0.514638 0 0 0 0 0.878125 0 0 0 0.27 0"
					/>
					<feBlend mode="normal" in2="shape" result="effect1_innerShadow_1_21" />
				</filter>
				<filter
					id="filter1_b_1_21"
					x="195"
					y="167"
					width="427.534"
					height="427.534"
					filterUnits="userSpaceOnUse"
					color-interpolationfilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
					<feComposite
						in2="SourceAlpha"
						operator="in"
						result="effect1_backgroundBlur_1_21"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_backgroundBlur_1_21"
						result="shape"
					/>
				</filter>
				<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
					<use xlinkHref="#image0_1_21" transform="scale(0.00195312)" />
				</pattern>
				<linearGradient
					id="paint0_linear_1_21"
					x1="288.434"
					y1="86.835"
					x2="704.489"
					y2="420.721"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#43CBFF" />
					<stop offset="1" stopColor="#9708CC" />
				</linearGradient>
				<image
					id="image0_1_21"
					width="512"
					height="512"
					xlinkHref="/remove_back/magic_bg_explore.png"
					alt="AI generated image in anime style"
				/>
			</defs>
		</svg>
	);
}

export default ExploreIcon;
